const GET_SHOPS = "GET_SHOPS";
const GET_SHOPS_SUCCESS = "GET_SHOPS_SUCCESS";
const GET_SHOPS_FAILURE = "GET_SHOPS_FAILURE";
const CLEAR_GET_SHOPS= "CLEAR_GET_SHOPS";

const shopsSymbols = {
  GET_SHOPS_SUCCESS,
  GET_SHOPS_FAILURE,
  GET_SHOPS,
  CLEAR_GET_SHOPS,
};
export default shopsSymbols;
